import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasosNavComponent } from '../../../componentes/formularios/pasos-nav/pasos-nav.component';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MapaUnicoPuntoComponent } from '../../../auxiliares/mapa-unico-punto/mapa-unico-punto.component';
import { AlarmasRoutingModule } from './routing';
import { MapaFacilComponent } from '../../../auxiliares/mapa-facil/mapa-facil.component';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';
import { DateRangeSelectorComponent } from '../../../auxiliares/date-range-selector/date-range-selector.component';
import { ListadoAlarmasDomiciliariasComponent } from './alarmas-domiciliarias/listado-alarmas-domiciliarias/listado-alarmas-domiciliarias.component';
import { MatDialogActions } from '@angular/material/dialog';
import { MapDrawMapboxComponent } from '../../../auxiliares/map-draw-mapbox/map-draw-mapbox.component';
import { FlotanteAlarmasComponent } from './mapa-alarmas/flotante-alarmas/flotante-alarmas.component';
import { MapaAlarmasComponent } from './mapa-alarmas/mapa-alarmas.component';
import { DetallesAlarmaEventosComponent } from './alarmas-domiciliarias/detalles-alarma/detalles-alarma-eventos/detalles-alarma-eventos.component';
import { DetallesAlarmaEventosDetallesComponent } from './alarmas-domiciliarias/detalles-alarma/detalles-alarma-eventos/detalles-alarma-eventos-detalles/detalles-alarma-eventos-detalles.component';
import { ListadoConfigsEventosComponent } from '../../standalone/configs-eventos/listado-configs-eventos/listado-configs-eventos.component';
import { ListadoNotasComponent } from '../../standalone/notas/listado-notas/listado-notas.component';
import { ListadoConfigEventoUsuarioComponent } from '../../standalone/config-evento-usuario/listado-config-evento-usuario/listado-config-evento-usuario.component';
import { StreamCamaraComponent } from '../../standalone/stream-camara/stream-camara.component';
import { CamarasMultipleComponent } from '../../standalone/camaras-multiple/camaras-multiple.component';
import { CrearAlarmaDomiciliariaCompletoComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/crear-alarma-domiciliaria-completo.component';
import { CrearNotaAlarmaCompletoComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/crear-editar-nota-alarma-completo/crear-editar-nota-alarma-completo.component';
import { AgregarCanalCamaraCompletoComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/agregar-canal-camara-completo/agregar-canal-camara-completo.component';
import { JerarquiaClienteComponent } from '../../standalone/jerarquia-cliente/jerarquia-cliente.component';
import { ChartComponent } from '../../../auxiliares/chart/chart.component';
import { ChartOrganizationComponent } from '../../../auxiliares/chart-organization/chart-organization.component';
import { UploadFileComponent } from '../../../auxiliares/upload-file/upload-file.component';
import { DatetimePickerComponent } from '../../../auxiliares/datetime-picker/datetime-picker.component';
import { AgregarInfoZonaCompletoComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/agregar-infozona-completo/agregar-infozona-completo.component';
import { AgregarHorarioCompletoComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/agregar-horario-completo/agregar-horario-completo.component';
import { VisualizadorHorarioComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/visualizador-horario/visualizador-horario.component';
import { VisualizadorHorarioTabComponent } from './alarmas-domiciliarias/detalles-alarma/visualizador-horario-tab/visualizador-horario-tab.component';
import { CardComponent } from '../../../auxiliares/cards/cards.component';
import { MapaUbicarComponent } from '../../../auxiliares/mapas/mapa-ubicar/mapa-ubicar.component';
import { SelectorTipoMapaComponent } from '../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { DetallesAlarmaInfoComponent } from './alarmas-domiciliarias/detalles-alarma/detalles-alarma-info/detalles-alarma-info.component';
import { DetallesAlarmaComponent } from './alarmas-domiciliarias/detalles-alarma/detalles-alarma.component';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';
import { SimConfigComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/sim-config/sim-config.component';
import { DataListComponent } from './alarmas-domiciliarias/crear-alarma-domiciliaria-completo/data-list/data-list.component';
import { EventosGenericosModule } from '../eventos-genericos/module';
import { AdministracionModule } from '../administracion/module';
import { ListadoExcepcionesComponent } from '../../standalone/excepcion/listado/listado.component';
import { ListadoLogsCrudosComponent } from '../logs/listado-logs-crudos/listado-logs-crudos.component';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { HintComponent } from '../../../componentes/hint/hint.component';
import { ConfigHorariosAtencionComponent } from '../../standalone/config-horarios-atencion/config-horarios-atencion.component';
import { ListadoAsignacionsComponent } from '../../standalone/asignacions/listado-asignacions/listado-asignacions.component';

@NgModule({
  declarations: [
    //Mapa
    FlotanteAlarmasComponent,
    MapaAlarmasComponent,
    //Alarmas
    ListadoAlarmasDomiciliariasComponent,
    DetallesAlarmaInfoComponent,
    DetallesAlarmaComponent,
    DetallesAlarmaEventosComponent,
    DetallesAlarmaEventosDetallesComponent,
    //CrearAlarmas
    CrearAlarmaDomiciliariaCompletoComponent,
    CrearNotaAlarmaCompletoComponent,
    AgregarCanalCamaraCompletoComponent,
    AgregarInfoZonaCompletoComponent,
    AgregarHorarioCompletoComponent,
    VisualizadorHorarioComponent,
    VisualizadorHorarioTabComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    PasosNavComponent,
    AlarmasRoutingModule,
    MatDialogActions,
    EventosGenericosModule,
    AdministracionModule,
    MapaUnicoPuntoComponent,
    MapaFacilV2Component,
    DateRangeSelectorComponent,
    MapDrawMapboxComponent,
    ChartComponent,
    ChartOrganizationComponent,
    DatetimePickerComponent,
    UploadFileComponent,
    CardComponent,
    MapaUbicarComponent,
    SelectorTipoMapaComponent,
    ListadoNotasComponent,
    ListadoConfigsEventosComponent,
    ListadoConfigEventoUsuarioComponent,
    StreamCamaraComponent,
    CamarasMultipleComponent,
    JerarquiaClienteComponent,
    SimConfigComponent,
    DataListComponent,
    HintComponent,
    EventosGenericosModule,
    AdministracionModule,
    ListadoExcepcionesComponent,
    MapCardComponent,
    ...PIEZAS_DETALLE,
    ConfigHorariosAtencionComponent,
    ListadoAsignacionsComponent,
    ListadoLogsCrudosComponent,
  ],
})
export class AlarmasModule {}
